import { useColorMode } from '../../../shared/features/theme/components/ColorModeProvider';
import { truckStatusColors } from '../adapters/truck-layers';
import { TRUCK_MAP_STATUS_LABELS, TRUCK_MAP_STATUSES } from '../policies/truck-map-status';

/** Which dot colour is which status, drawn from the same palette as the map's layers. */
export function TruckStatusLegend() {
  const { mode } = useColorMode();
  const colors = truckStatusColors(mode);
  return (
    <ul aria-label="Map legend" className="flex flex-wrap gap-x-4 gap-y-1.5 text-xs text-muted">
      {TRUCK_MAP_STATUSES.map((status) => (
        <li key={status} className="flex items-center gap-1.5">
          <span aria-hidden className="size-2.5 rounded-full border border-surface" style={{ backgroundColor: colors[status] }} />
          <span className="text-fg">{TRUCK_MAP_STATUS_LABELS[status]}</span>
        </li>
      ))}
    </ul>
  );
}
